import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  // namespaced: true,
  state() {
    return {
      isAuthenticated: false,
      uId: null,
      token: null,

      today: null,
      todayActual: null,
      tomorrowActual: null,
      todaysDateDisplay: null,
      dayOfWeek: null,

      reasons: null,

      program: null,
    };
  },
  mutations,
  actions,
  getters,
};
